import React, { useState } from 'react';
import styled from 'styled-components';

import Section from '@/components/templates/doctor/detail/components/Section/Section';
import { DoctorTreatment } from '@/types/doctor';

interface Props {
  doctorTreatments: Array<DoctorTreatment>;
}

const MAX_DOCTOR_TREATMENT_COUNT = 12;

const DoctorTreatments = ({ doctorTreatments }: Props) => {
  const [isUnfoldable, setIsUnfoldable] = useState<boolean>(doctorTreatments.length > MAX_DOCTOR_TREATMENT_COUNT);
  function unfold() {
    setIsUnfoldable(!isUnfoldable);
  }

  return (
    <>
      <Section>
        <Section.Title title={'진료 증상'} />
        <Treatments>
          {!isUnfoldable ? (
            <>
              {doctorTreatments.map((treatment) => (
                <Treatment key={treatment.treatmentId}>{treatment.treatmentName}</Treatment>
              ))}
            </>
          ) : (
            <>
              {doctorTreatments.slice(0, MAX_DOCTOR_TREATMENT_COUNT).map((treatment) => (
                <Treatment key={treatment.treatmentId}>{treatment.treatmentName}</Treatment>
              ))}
              {isUnfoldable ? (
                <>
                  <MoreButton onClick={unfold}>...</MoreButton>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Treatments>
      </Section>
    </>
  );
};

export default DoctorTreatments;

const Treatments = styled.div`
  display: flex;
  padding: 0 24px;
  gap: 8px;
  flex-wrap: wrap;
  align-self: stretch;
`;

const Treatment = styled.span`
  display: flex;
  padding: 0 8px;
  height: 28px;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  ${({ theme }) => `
    border: 1px solid ${theme.color.gray50};
    ${theme.typography.UI13M}
    color: ${theme.color.gray600}
  `}
`;

const MoreButton = styled(Treatment)``;
